import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Customizer } from './Customizer';
import defaultObjectBackground from './2345.png';
import './index.css';

// Get configuration from window.customizer if available
const config = (window as any).customizer || {
  containerWidth: 500,
  containerHeight: 500,
  canvasWidth: 108,
  canvasHeight: 160,
  canvasLeft: 196,
  canvasTop: 190,
  allowedBackgroundColors: [
    '#FFFFFF', '#E5E7EB', '#6B7280', '#000000',
    '#3B82F6', '#60A5FA', '#10B981', '#F87171'
  ],
  allowedTextColors: [
    '#000000', '#FFFFFF', '#EF4444', '#F59E0B',
    '#10B981', '#3B82F6', '#6366F1', '#8B5CF6',
    '#EC4899', '#6B7280', '#78350F', '#064E3B'
  ],
  allowedFonts: [
    { name: 'Bree Serif', value: 'Bree Serif' },
    { name: 'Open Sans', value: 'Open Sans' },
    { name: 'Delius', value: 'Delius' }
  ],
  allowCustomTextColors: true,
  allowCustomBackgroundColors: true,
  transparentBackground: true,
  objectBackground: defaultObjectBackground,
  initialDesign: null,
  onSave: (design: any) => {
    console.log('Design saved:', design);
  }
};

// Create root and render app
const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <Customizer {...config} />
    </StrictMode>
  );
}